var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExpandMore24Px1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_expand_more_24px",
    d: "M7.06,0,4,3.09.94,0,0,.951,4,5,8,.951Z",
    transform: "translate(0 8) rotate(-90)",
    fill: "#203662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExpandMore24Px1);
export default __webpack_public_path__ + "static/media/ic_expand_more_24px (1).1849118a9e3718badd8626ee31f8cab0.svg";
export { ForwardRef as ReactComponent };